import React from 'react';
import { useViewMode } from 'app/shared/hooks/useViewMode';
import { emitTrackToggleViewModeEvent } from 'app/shared/models/Clickstream/ListingsClickstreamEvents';
import ListIcon from './ListIcon';
import { FeedIcon } from 'app/shared/halo/components/ui/icons';
import Button from 'app/shared/core/Button';
import { feedButton, mobileToggleIcon } from './viewModeToggle.styles';

const MobileViewModeToggle = () => {
  const [viewMode, setViewMode] = useViewMode();
  const isGrid = viewMode === 'grid';

  return (
    <Button
      btnType="secondary"
      size="sm"
      className={feedButton}
      icon={isGrid ? <FeedIcon className={mobileToggleIcon} /> : <ListIcon className={mobileToggleIcon} />}
      onClick={() => {
        emitTrackToggleViewModeEvent({ targetView: isGrid ? 'feed' : 'list' });
        setViewMode(isGrid ? 'feed' : 'grid');
      }}
      aria-label={isGrid ? 'Switch to feed view' : 'Switch to list view'}
    >
      {isGrid ? 'Feed' : 'List'}
    </Button>
  );
};

export default MobileViewModeToggle;
